import { t } from "i18next";
import { Controller, useFormContext } from "react-hook-form";
import { RadioButton } from "ui";

import { OrderStatus, OrderUnpackingStatus } from "../../../../constants";
import { FilterFormValues } from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

export const UnpackingStatusBlock = () => {
  const { control, setValue } = useFormContext<FilterFormValues>();

  const handleUnpackingStatusChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: string) => void
  ) => {
    setValue(
      "statuses",
      e.currentTarget.value ? [OrderStatus.Cancelled, OrderStatus.Failed] : []
    );

    onChange(String(e.currentTarget.value));
  };

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>
        {t("Unpacking Status")}
      </h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name="unpackingStatus"
          render={({ field: { value, onChange } }) => (
            <>
              <RadioButton
                checked={!value}
                value={undefined}
                onChange={(e) => handleUnpackingStatusChange(e, onChange)}
                label={"All"}
              />
              <RadioButton
                checked={value === OrderUnpackingStatus.WaitingToUnpack}
                value={OrderUnpackingStatus.WaitingToUnpack}
                onChange={(e) => handleUnpackingStatusChange(e, onChange)}
                label={"Waiting to unpack"}
              />

              <RadioButton
                checked={value === OrderUnpackingStatus.WaitingToReschedule}
                value={OrderUnpackingStatus.WaitingToReschedule}
                onChange={(e) => handleUnpackingStatusChange(e, onChange)}
                label={"Waiting to reschedule"}
              />

              <RadioButton
                checked={value === OrderUnpackingStatus.Unpacked}
                value={OrderUnpackingStatus.Unpacked}
                onChange={(e) => handleUnpackingStatusChange(e, onChange)}
                label={"Unpacked and was not packaged"}
              />
            </>
          )}
        />
      </div>
    </div>
  );
};
